import Vue from 'vue'
import Slick from 'vue-slick';
import Loader from './../components/shared/Loader.vue'
import Navbar from './../components/shared/Navbar.vue'

import Slider from './../components/shared/Slider.vue'
import Us from './../components/shared/Us.vue'
import ProductsAndServices from './../components/shared/ProductsAndServices.vue'
import Experience from './../components/shared/Experience.vue'
import Clients from './../components/shared/Clients.vue'
import HumanTalent from './../components/shared/HumanTalent.vue'
import ContactModal from './../components/shared/ContactModal.vue'
import MenuIcon from './../components/shared/Menu.vue'
import CloseIcon from './../components/shared/Close.vue'
import Protocol from './../components/shared/Protocol.vue'

Vue.component('slick', Slick)
Vue.component('app-loader', Loader)
Vue.component('app-navbar', Navbar)

Vue.component('app-slider', Slider)
Vue.component('app-us', Us)
Vue.component('app-products-and-services', ProductsAndServices)
Vue.component('app-experience', Experience)
Vue.component('app-clients', Clients)
Vue.component('app-human-talent', HumanTalent)

Vue.component('app-contact-modal', ContactModal)
Vue.component('app-menu-icon', MenuIcon)
Vue.component('app-close-icon', CloseIcon)
Vue.component('app-protocol', Protocol)



// WEBPACK FOOTER //
// ./src/vue/components.js